import axiosInstance from "@/api/axios-instance";
import { FormPreview, FormProvider } from "@/pages/forms/types/form";

// Previews a form by source_id (title + question count + workspace).
// Throws on 404 ("form not found") so the wizard can surface it.
export async function getFormPreview(
  sourceId: string,
  provider: FormProvider = "TYPEFORM",
): Promise<FormPreview> {
  const response = await axiosInstance.get("/forms/preview", {
    params: { source_id: sourceId, provider },
  });
  return response.data as FormPreview;
}
